import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function HeartIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 122 107";
  const iconTransform = withCircle ? "translate(12.5 16) scale(0.45)" : "";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          d="M88.442 0a32.634 32.634 0 00-23.496 9.991c-1.44 1.492-2.785 3.008-4.51 4.851-1.819-1.962-3.288-3.733-4.935-5.31C48.886 3.208 41.373.04 33.106.04c-2.99 0-6.083.415-9.266 1.245A32.014 32.014 0 00.002 32.192c-.072 9.81 3.808 18.009 10.61 24.858C22.53 69.067 34.537 81 46.493 92.984c4.607 4.604 9.192 9.251 13.92 14.016.607-.545.98-.876 1.337-1.227 16.23-16.257 32.46-32.509 48.692-48.76a33.619 33.619 0 003.326-3.78c7.781-10.525 9.927-22.021 4.4-34.062A32.628 32.628 0 0088.442 0m.002 8c1.397 0 2.807.121 4.188.359 8.054 1.389 14.876 6.664 18.265 14.15 4.025 8.768 2.87 17.25-3.535 25.932a25.84 25.84 0 01-2.508 2.848l-.037.035-.034.035a370585.768 370585.768 0 00-44.294 44.353 2377.825 2377.825 0 00-8.333-8.379c-4.459-4.469-8.925-8.931-13.392-13.393a7152.938 7152.938 0 01-22.477-22.526C10.66 45.746 7.95 39.478 8.003 32.203a24.124 24.124 0 014.996-14.628c3.22-4.171 7.798-7.21 12.864-8.549 2.508-.655 4.945-.986 7.244-.986 6.228 0 11.745 2.379 16.863 7.272.87.832 1.748 1.812 2.767 2.947.584.651 1.188 1.325 1.836 2.023l5.838 6.296 5.868-6.27c.713-.763 1.363-1.471 1.982-2.145.886-.964 1.651-1.797 2.447-2.621A24.751 24.751 0 0188.444 8"
          fillRule="evenodd"
          fill={color}
        />
      </g>
    </Svg>
  );
}
